const PUBLIC = 0;
const CONFIDENTIAL = 1;
const RESERVED = 2;

export const PRIVACITY = {
  PUBLIC,
  CONFIDENTIAL,
  RESERVED
};


